import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import {
  selectSpecContractIsFail,
  selectSpecContractIsOpenByKind,
} from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

import infoPng from '/img/contract/info.png';

interface ContractInfoProps {
  className?: string;
  kind: 'Blitz' | 'BlitzPlus';
}

const ContractInfo: FC<ContractInfoProps> = ({ className, kind }) => {
  const isOpen = useAppSelector((state) =>
    selectSpecContractIsOpenByKind(state, kind),
  );
  const isFail = useAppSelector((state) =>
    selectSpecContractIsFail(state, kind),
  );
  const { t } = useTranslation();

  return (
    !isOpen &&
    !isFail && (
      <div className={cn(css.contractInfo, className)}>
        <Picture img={infoPng} className="w-8 h-8" alt="info" />
        <StringXSmall className="!text-white/80">
          {t('No rewards if time expires!')}
        </StringXSmall>
      </div>
    )
  );
};

export { ContractInfo };
